const SAMPLE_COLLECTION_RETURN_KIT_ID_KEY = 'ash.sample-collection.return-kit-id'

function writeStoredKitId(kitId: string): void {
  try {
    window.sessionStorage.setItem(SAMPLE_COLLECTION_RETURN_KIT_ID_KEY, kitId)
  } catch {
    // Private mode can block storage. The page keeps the value for this visit.
  }
}

/** Reads the kit id saved for session-expired resume on sample collection. */
export function readSampleCollectionReturnKitId(): string | null {
  if (typeof window === 'undefined') return null
  try {
    const stored = window.sessionStorage.getItem(SAMPLE_COLLECTION_RETURN_KIT_ID_KEY)?.trim()
    return stored || null
  } catch {
    return null
  }
}

export function persistSampleCollectionReturnKitId(kitId: string): void {
  if (typeof window === 'undefined') return
  const trimmed = kitId.trim()
  if (!trimmed) return
  writeStoredKitId(trimmed)
}

/** Copies `kit_id` from a query string into session storage when present. */
export function persistSampleCollectionReturnKitIdFromSearch(search: string): void {
  const kitId = new URLSearchParams(search).get('kit_id')?.trim()
  if (kitId) persistSampleCollectionReturnKitId(kitId)
}

export function clearSampleCollectionReturnKitId(): void {
  if (typeof window === 'undefined') return
  try {
    window.sessionStorage.removeItem(SAMPLE_COLLECTION_RETURN_KIT_ID_KEY)
  } catch {
    // ignore
  }
}
